export const enum NewCategoryCreateTrigger {
    OnEnterOnTextField,
    OnBlurOnTextField,
    OnBlurOnColorPicker,
    OnSelectColor,
}

export default {
    categoryOptionsyNewCategoryCreate: {
        datapoint: {
            name: 'Category_Options_newCategoryCreated',
            customData: (createSource: NewCategoryCreateTrigger) => [createSource],
        },
    },
};
